(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["period-monthly-plans"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var loading = false;

    function getCartAddUrl() {
      if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
        return window.theme.routes.cartAdd;
      }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.replace(/\/?$/, '/') + 'cart/add.js';
    }

    function getSelectedVariantId(card) {
      var select = card.querySelector('.monthly-plans__select');

      if (select) {
        return select.value;
      }

      var fallbackVariant = card.querySelector('.variants-to-cart');
      if (!fallbackVariant) {
        return null;
      }

      return fallbackVariant.textContent.trim().split('splitter')[0].trim();
    }

    function getSellingPlanId(card) {
      if (card.dataset.sellingPlanId) {
        return card.dataset.sellingPlanId;
      }

      var sellingPlanEl = card.querySelector('.sellingPlanID');
      return sellingPlanEl ? sellingPlanEl.textContent.trim() : null;
    }

    function addMonthlyPlanToCart(variantId, sellingPlanId, button) {
      if (loading) {
        return;
      }

      if (!variantId || !sellingPlanId) {
        alert('Please select a size before continuing.');
        return;
      }

      loading = true;
      button.classList.add('btn--loading');
      button.disabled = true;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('selling_plan', sellingPlanId);

      fetch(getCartAddUrl(), {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          var data = result.data;

          if (!result.ok || data.status === 422) {
            alert(data.description || data.message || 'Unable to add to cart');
            return;
          }

          if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') {
            window.location = window.theme.routes.cartPage;
            return;
          }

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: {
                product: data,
                addToCartBtn: button
              }
            })
          );
        })
        .catch(function () {
          alert('Unable to add to cart');
        })
        .finally(function () {
          loading = false;
          button.classList.remove('btn--loading');
          button.disabled = false;
        });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.monthly-plans__button');
      if (!button) {
        return;
      }

      event.preventDefault();

      var card = button.closest('.monthly-plans__col-content');
      if (!card) {
        return;
      }

      addMonthlyPlanToCart(
        getSelectedVariantId(card),
        getSellingPlanId(card),
        button
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
